import "./style.scss";

export function quote_block() {
  const block = document.querySelector(".quote_block");
  if (!block) return;
}
